<template>
  <content-dialog
    ref="dialog"
    v-model="dialogOpen"
    fullscreen-mobile
    height="85vh"
    :loading="loading"
    :width="`${700 + (filterDrawerOpen ? filterDrawerWidth : 0)}px`"
    @hide="$emit('hide')"
  >
    <template #card>
      <q-layout
        v-if="$refs.dialog"
        container
        view="hHr lpR fFr"
      >
        <q-header
          class="blurred-container text-black"
        >
          <q-toolbar>
            <q-btn
              v-close-popup
              dense
              flat
              round
              icon="close"
            />

            <page-toolbar-title>
              {{ title }}
            </page-toolbar-title>

            <slot name="buttons" />

            <q-btn
              flat
              round
              dense
              icon="mdi-filter-variant"
              class="q-mr-sm"
              @click="filterDrawerOpen = !filterDrawerOpen"
            >
              <q-tooltip>Toggle Filters</q-tooltip>
            </q-btn>
          </q-toolbar>

          <q-toolbar class="bg-transparent q-px-md">
            <q-input
              v-model="formFilters.search"
              placeholder="Search..."
              type="search"
              dense
              outlined
              clearable
              style="max-width: 225px;"
              :debounce="750"
            >
              <template #prepend>
                <q-icon name="search" />
              </template>
            </q-input>
          </q-toolbar>
        </q-header>

        <q-page-container>
          <q-page>
            <slot />

            <List
              :filtered-forms="filteredResults.forms"
              :display-custom-groups="!isSearching"
              :custom-groups="customGroups"
              :loading="loading"
              :anchor="null"
            >
              <template #form="{ form, refKey }">
                <slot
                  name="form"
                  :form="form"
                  :ref-key="refKey"
                />
              </template>

              <template #group="{ anchor, group, index }">
                <slot
                  name="group"
                  :anchor="anchor"
                  :group="group"
                  :index="index"
                />
              </template>
            </List>
          </q-page>
        </q-page-container>

        <q-drawer
          v-model="filterDrawerOpen"
          :width="filterDrawerWidth"
          :breakpoint="filterBreakpoint"
          side="right"
          show-if-above
          class="bg-drawer"
        >
          <FiltersDrawer
            :show-default-filters="showDefaultFilters"
            :form-filters="formFilters"
            :categories="allCategories"
            :filtered-results="filteredResults"
            :is-category-disabled-func="isCategoryDisabled"
            @toggle="toggleCategory"
          >
            <template v-if="$slots['filters']" #filters>
              <slot name="filters" />
            </template>
          </FiltersDrawer>
        </q-drawer>

        <q-footer
          v-if="hasBottomSlot"
          class="blurred-container text-black"
        >
          <q-toolbar>
            <slot name="bottom" />
          </q-toolbar>
        </q-footer>
      </q-layout>
    </template>
  </content-dialog>
</template>

<script>
import FiltersDrawer from 'components/app/forms/partials/list/filters/FiltersDrawer.vue'
import List from 'components/app/forms/partials/list/List'

import filtersMixin from './searchMixin'

/**
 * This dialog is a base and should be extended upon where appropriate
 */
export default {
  components: {
    List, FiltersDrawer
  },
  mixins: [filtersMixin],
  props: {
    // Array of all forms
    forms: {
      type: Array,
      default: () => {
        return []
      }
    },
    // Is loading
    loading: {
      type: Boolean,
      default: false
    },
    // Dialog title
    title: {
      type: String,
      required: true
    },
    // Show default filter toggles in sidebar (status, master copies, beta forms etc)
    showDefaultFilters: {
      type: Boolean,
      default: false
    },
    // Custom groups to prepend to main list
    customGroups: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['hide', 'load'],
  data () {
    return {
      dialogOpen: false,
      filterBreakpoint: 699,
      filterDrawerWidth: 300,
      filterDrawerOpen: false
    }
  },
  computed: {
    hasBottomSlot () {
      return !!this.$slots.bottom
    }
  },
  methods: {
    open () {
      this.dialogOpen = true
      this.resetFilters()
      this.$emit('load')
    },
    close () {
      this.dialogOpen = false
    },
    refresh () {
      this.$emit('load')
    }
  }
}
</script>
